const DEFAULT_LOADING_TEMPLATE = `
  <p style="text-align: center; margin-top: 50px; width: 100%; font-family: sans-serif">
    Loading...
  </p>
`;

export default function openPopup({
  width = '800',
  height = '600',
  location = '',
  name = '_blank',
  loadingTemplate = DEFAULT_LOADING_TEMPLATE,
}) {
  return new Promise(resolve => {
    const { availWidth, availHeight } = window.screen;
    const centerLeft = parseInt((availWidth - width) / 2, 10);
    const centerTop = parseInt((availHeight - height) / 2, 10);
    const size = `width=${width},height=${height},left=${centerLeft},top=${centerTop}`;
    const features = 'status=no,location=no,scrollbars=yes,resizable=yes';

    const popup = window.open(location, name, `${size},${features}`);
    popup.document.body.innerHTML = loadingTemplate;

    resolve(popup);
  });
}
